module.exports = __webpack_public_path__ + "img/w20-b1.e070b40e.jpg";